export default "__VITE_ASSET__BNirp8Lf__"